<app-banner [heading]="'TRANSFER CERTIFICATE(TC)'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main">
	
	<!-- ======= About Section ======= -->
    <section id="about" class="about">

      <div class="container">
        <div class="row">

          <div class="col-lg-6 col-md-6">
            <div class="about-img"><a> Dhruv
              <img src="assets/img/tc.jpg" alt="best school in kurukshetra"> </a>
            </div>
          </div>
		  <div class="col-lg-6 col-md-6">
            <div class="about-img"> <a>Sagar
              <img src="assets/img/tc.jpg" alt="best school in kurukshetra"> </a>
            </div>
          </div>
		  <div class="col-lg-6 col-md-6">
            <div class="about-img"> <a > Gurnoor Singh
              <img src="assets/img/tc.jpg" alt="best school in kurukshetra"> </a>
            </div>
          </div>
		  <div class="col-lg-6 col-md-6">
            <div class="about-img"><a >Gautam
              <img src="assets/img/tc.jpg" alt="best school in kurukshetra">
            </a></div><a href="assets/img/tc/gautam.pdf">
          </a></div><a href="assets/img/tc/gautam.pdf">

          
		</a></div><a href="assets/img/tc/gautam.pdf">
      </a></div><a href="assets/img/tc/gautam.pdf">
	</a></section><!-- End About Section --><a href="assets/img/tc/gautam.pdf">
	
	
    

	
	
    
    
  </a></main>